<!--
 * @Author       : 花裤衩<白永明><yongming.bai@outlook.com>
 * @Date         : 2026-02-05 18:30:15 +0800
 * @LastEditors  : 花裤衩<白永明><yongming.bai@outlook.com>
 * @LastEditTime : 2026-03-03 18:08:28 +0800
 * @FilePath     : /ai-agent-lumina/src/components/global/textarea/src/izt-textarea.vue
 * @Description  : 富文本
-->
<style lang="scss" scoped>
  .input-box {
    display: flex;
    height: fit-content;
    background-color: #FFFFFF;
    border-radius: 24px;
    overflow: hidden;
    padding: 24px;
    border: 2px solid rgba(0, 0, 0, 0.35);
    // 隐藏滚动条
    textarea {
      max-height: 300px;
      background: transparent;
      height: 100%;
      flex: 1;
      border: none;
      line-height: 1.3;
      font-size: 26px;
      color: rgba(0, 0, 0, 0.65);
      &::placeholder {
        color: rgba($color: #000000, $alpha: .25);
      }
    }
  }
</style>

<template>
  <div class="input-box">
    <textarea
      class="overflow-style"
      ref="textareaRef"
      v-model="value"
      :placeholder="placeholder"
      @input="autoResize"
      @blur="handleBlur"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, computed, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  trim: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'resize'])

const value = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
  }
})

const handleBlur = () => {
  if (props.trim && props.modelValue) {
    const trimmedVal = props.modelValue.trim()
    if (trimmedVal !== props.modelValue) {
      emit('update:modelValue', trimmedVal)
    }
  }
}
watch(() => value.value, (value) => nextTick(autoResize))

const textareaRef = ref(null)

const autoResize = () => {
  const el = textareaRef.value
  if (!el) return

  // 1. 重置高度，拿真实内容高度
  el.style.height = 'auto'

  const rect = el.getBoundingClientRect()
  const SAFE_GAP = 24
  const maxHeight = window.innerHeight - rect.top - SAFE_GAP

  // 2. 计算目标高度
  const targetHeight = Math.min(el.scrollHeight, maxHeight)
  el.style.height = targetHeight + 'px'

  // 3. **关键：始终滚动到最底部**
  // 放在 nextTick 或 requestAnimationFrame 中更稳
  requestAnimationFrame(() => {
    el.scrollTop = el.scrollHeight
  })

  emit('resize', targetHeight)
}
</script>